import { SetStateAction, useAtom, WritableAtom } from 'jotai';
import { useCallback } from 'react';
import { GridPaginationModel } from '@mui/x-data-grid-pro';

type UseAtomPaginationChangeProps = {
  pageAtom: WritableAtom<number, [newValue: SetStateAction<number>], void>;
  rowsPerPageAtom: WritableAtom<number, [newValue: SetStateAction<number>], void>;
};

export const useAtomPaginationChange = ({
  pageAtom,
  rowsPerPageAtom,
}: UseAtomPaginationChangeProps) => {
  const [rowsPerPage, setRowsPerPage] = useAtom(rowsPerPageAtom);
  const [page, setPage] = useAtom(pageAtom);

  const onPaginationChange = useCallback(
    (pagination: GridPaginationModel) => {
      if (pagination.page !== page) {
        setPage(pagination.page);
      }

      if (pagination.pageSize !== rowsPerPage) {
        setRowsPerPage(pagination.pageSize);
      }
    },
    [page, rowsPerPage, setPage, setRowsPerPage],
  );

  return { page, rowsPerPage, onPaginationChange };
};
